<template lang="pug"></template>

<script>
export default {
    name: 'BotaoInteligenciaTerritorial',
    componentOptions: {
        title: 'Inteligência Territorial',
        actions: [
            [
                {
                    name: 'Inteligência Territorial',
                    iconClass: 'lyra-icon lyra-inteligencia-territorial',
                    showView: false,
                    action: 'abrirInteligencia',
                    route: 'InteligenciaTerritorial'
                }
            ]
        ]
    },

    methods: {
        abrirInteligencia() {
            if (this.$route.name !== 'InteligenciaTerritorial') {
                this.$router.push({ name: 'InteligenciaTerritorial' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
